"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderImg = exports.ProviderImgWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const image_component_1 = __importDefault(require("@kyruus/image-component"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.ProviderImgWrapper = styled_1.default.div `
  height: ${({ isCircle }) => (isCircle ? constants_1.PROFILE_IMAGE_WIDTH : 'fit-content')};
  width: ${constants_1.PROFILE_IMAGE_WIDTH};
  overflow: hidden;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  background: ${(_a) => {
    var { imageEnhancementEnabled } = _a, rest = __rest(_a, ["imageEnhancementEnabled"]);
    return imageEnhancementEnabled
        ? 'unset'
        : (0, ui_theme_1.fromTheme)('color_image_placeholder')(rest);
}};
  border-radius: ${(_a) => {
    var { isCircle, imageEnhancementEnabled } = _a, props = __rest(_a, ["isCircle", "imageEnhancementEnabled"]);
    const customerConfigValue = (0, ui_theme_1.fromTheme)('provider_profile_provider_image_border_radius')(props);
    if (isCircle) {
        return '50%';
    }
    if (imageEnhancementEnabled) {
        return (0, ui_theme_1.fromTheme)('border_radius_medium');
    }
    return customerConfigValue ? customerConfigValue : 'unset';
}};

  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    align-self: center;
    margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 0;
  }

  // position next to name/specialties/badges on screens between small and medium width
  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    flex: 0 0 ${constants_1.PROFILE_IMAGE_WIDTH};
  }
`;
exports.ProviderImg = (0, styled_1.default)(image_component_1.default) `
  width: '100%';
  max-width: ${({ imageEnhancementEnabled }) => imageEnhancementEnabled ? '100%' : constants_1.PROFILE_IMAGE_WIDTH};
  height: ${({ isCircle, isLandscape }) => isCircle && isLandscape ? constants_1.PROFILE_IMAGE_WIDTH : 'auto'};
  object-fit: ${({ isLandscape }) => (isLandscape ? 'cover' : 'initial')};
  // override the default border radius for the image
  border-radius: unset !important;
`;
//# sourceMappingURL=profile-image.styles.js.map